import React from 'react'
import { observer } from 'mobx-react'
import { CardContent } from 'components/Card'
import Button from 'components/Button'
import JobProgressionViewModel from '../JobProgressionViewModel'
import { JobProgressionFlow } from 'jobs/progression/JobProgression'

interface Props {
  vm: JobProgressionViewModel
}

export default observer(function WaitingOnAdminProgressionActions({
  vm,
}: Props) {
  return (
    <>
      <CardContent>
        <Button
          type="primary"
          size="wide-slim"
          onClick={() => vm.answerReadyToFile(true)}
          dataTest="job-progression-resume-filing-button"
        >
          {vm.currentProgressionFlow ===
          JobProgressionFlow.OUTSOURCING_EXTENSION
            ? 'Continue on Client’s Behalf'
            : 'Resume Filing on Client’s Behalf'}
        </Button>
      </CardContent>
    </>
  )
})
